/**
 * Storage
 * > - https://github.com/marcuswestin/store.js
 * > - https://github.com/marcuswestin/store.js#make-your-own-build
 * @example
 *   import storage from './storage'
 *   storage.get( ... )
 *   storage.set( ... )
 *   storage.remove( ... )
 *   storage.clearAll()
 *   storage.each( ... )
 */

import store from 'store'

export default store



// WEBPACK FOOTER //
// ./src/libraries/utils/storage.js